// sessionStorage key for the nonce the Google sign-in button stores and the callback checks.
export const GOOGLE_OAUTH_NONCE_KEY = 'google_oauth_nonce'
